import { Box } from 'braid-design-system';
import type React from 'react';

import { base, focused, focusRing, invalid } from './index.css';

interface Props {
  children: React.ReactNode;
  isFocused: boolean;
  isInvalid?: boolean;
}

export const CustomBraidTextField = ({
  isFocused,
  isInvalid,
  children,
}: Props) => {
  const getClass = () => {
    if (isFocused) {
      return focused;
    } else if (isInvalid) {
      return invalid;
    }
    return base;
  };
  return (
    <FocusRing isFocused={isFocused}>
      <Box
        className={getClass()}
        paddingTop="xsmall"
        paddingBottom="xxsmall"
        paddingX="xxsmall"
      >
        {children}
      </Box>
    </FocusRing>
  );
};

interface Props {
  isFocused: boolean;
  children: React.ReactNode;
}

const FocusRing = ({ isFocused, children }: Props) => (
  <Box className={isFocused ? focusRing : null}>{children}</Box>
);
